export default function useObserver(handleIntersect: IntersectionObserverCallback, optionsIntersect?: IntersectionObserverInit) {
    const options: IntersectionObserverInit = optionsIntersect ?? {
        root: null,
        rootMargin: '0px',
        threshold: 0
    };
    const observer = new IntersectionObserver(handleIntersect, options);
    return observer;
}